module.exports = __webpack_public_path__ + "img/thumbnail_AfricanBuffalo_m_normal.8af93ac2.png";